import { render, staticRenderFns } from "./EditarFamilia.vue?vue&type=template&id=6d991fcb&"
import script from "./EditarFamilia.vue?vue&type=script&lang=js&"
export * from "./EditarFamilia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports